import type MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: Array<MapProperty> = [
    /* id property does not exist on https://api.ats-workspace.com/$metadata/SiteObjectOnFloorPlanDto,
   the primary key is a combination here of the #floorplanId & the #siteObjectId,
   mimic this behaviour */
    {
        localName: 'id',

        defaultValue: 0,
        customImport: function (source: Record<string, unknown>): unknown {
            const siteObjectIdRaw: unknown = source['siteObjectId'] ?? 0;
            const floorPlanIdRaw: unknown = source['siteObjectId'] ?? 0;

            const siteObjectId: number = typeof siteObjectIdRaw === 'number' ? siteObjectIdRaw : 0;
            const floorPlanId: number = typeof floorPlanIdRaw === 'number' ? floorPlanIdRaw : 0;

            const id = (floorPlanId << 4) & siteObjectId;

            return id;
        },
        removeValueOnExport: true,
    },
    {
        localName: 'siteObjectId',

        defaultValue: 0,
    },
    {
        localName: 'floorPlanId',

        defaultValue: 0,
    },
    {
        localName: 'x',

        defaultValue: 0,
    },
    {
        localName: 'y',

        defaultValue: 0,
    },
    {
        localName: 'pinTypeId',

        defaultValue: 0,
    },
    {
        localName: 'pinColor',

        defaultValue: '',
    },
    {
        localName: 'siteObjectName',

        defaultValue: '',
    },
];

export default MAPPINGS;
